import React from 'react';
import Result360Page from '../Result360Page/Result360Page';

const Result60020Page = (props) => (
  <Result360Page
    {...props}
    surveyCode="60020"
    fallbackTitle="フォロワーシップ診断結果"
  />
);

export default Result60020Page;
